<template>
  <div class="drag-able" ref="dragAble">
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { addEvent, prEvent, removeEvent, addWheelEvent } from '@/utils'

export default defineComponent({
  setup () {
    return {}
  },

  mounted () {
    this.$nextTick(() => {
      this.drag()
      this.wheel()
    })
  },

  methods: {
    drag () {
      const drag = this.$refs.dragAble

      addEvent(drag, 'mousedown', function (ev) {
        var oEvent = prEvent(ev)
        var oParent = drag.parentNode

        var disX = oEvent.clientX - drag.offsetLeft
        var disY = oEvent.clientY - drag.offsetTop
        var startMove = function (ev) {
          if (oParent.setCapture) {
            oParent.setCapture()
          }
          var oEvent = ev || window.event
          var L = oEvent.clientX - disX
          var T = oEvent.clientY - disY

          drag.style.left = L + 'px'
          drag.style.top = T + 'px'

          oParent.onselectstart = function () {
            return false
          }
        }
        var endMove = function () {
          if (oParent.releaseCapture) {
            oParent.releaseCapture()
          }
          oParent.onselectstart = null

          removeEvent(oParent, 'mousemove', startMove)
          removeEvent(oParent, 'mouseup', endMove)
          removeEvent(window, 'mouseup', endMove)
        }
        addEvent(oParent, 'mousemove', startMove)
        addEvent(oParent, 'mouseup', endMove)
        addEvent(window, 'mouseup', endMove)
        return false
      })
    },

    wheel () {
      const drag = this.$refs.dragAble
      const _this = this;
      (function () {
        addWheelEvent(drag, function (delta) {
          const dwidth = document.body.clientWidth
          const dheight = document.body.clientHeight
          var ratioL =
              (this.clientX - (dwidth - 700) / 2 - drag.offsetLeft) /
              drag.offsetWidth
          var ratioT =
              (this.clientY - (dheight - 700) / 2 - drag.offsetTop) /
              drag.offsetHeight
          var ratioDelta = !delta ? 1 + 0.1 : 1 - 0.1
          var w = parseInt(drag.offsetWidth * ratioDelta)
          var h = parseInt(drag.offsetHeight * ratioDelta)
          var l = Math.round(this.clientX - (dwidth - 700) / 2 - w * ratioL)
          var t = Math.round(this.clientY - (dheight - 700) / 2 - h * ratioT)

          drag.style.width = w + 'px'
          drag.style.height = h + 'px'
          drag.style.left = l + 'px'
          drag.style.top = t + 'px'

          _this.$emit('resize', { w, h, l, t })
        })
      })()
    }
  }
})
</script>

<style lang="less" scoped>
.drag-able {
  position: absolute;
  cursor: move;
}
</style>
